<template>

  <div class="user">
    <!--添加任务-->

    <div class="common-level-rail" v-if="is_status">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="backClick">返回上一页</el-button>
    </div>
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="设备名称/终端号/IMEI">
          <el-input placeholder="请输入设备名称/终端号/IMEI" v-model="formInline.search">

          </el-input>
        </el-form-item>

        <el-form-item label="选择角色" prop="service_role_id">
        <el-select v-model="formInline.service_role_id" >
          <template v-for="(item,index) in serviceRoleList">
            <el-option
              :value="item.service_role_id"
              :key="index"
              :label="item.name"
            ></el-option>
          </template>
        </el-select>
      </el-form-item>


        <el-form-item label="所属服务商">
          <el-input placeholder="请输入所属服务商" v-model="formInline.service">

          </el-input>
        </el-form-item>



        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>


        <el-form-item>

            <el-button type="primary"  icon="el-icon-search" @click="getData">查询</el-button>
            <el-button  icon="el-icon-search" @click="reast">重置</el-button>

        </el-form-item>

        
      <div class="common-level-rail" v-if="formInline.dtype">
        <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">绑定设备</el-button>
      </div>

      </el-form>
    </div>


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="equip_belong_id" label="ID"></el-table-column>




            <el-table-column prop="money_statics" label="收入统计"></el-table-column>
            <el-table-column prop="commission_statics" label="佣金统计"></el-table-column>
            <el-table-column prop="rate" label="采用比例" label-width="150px">
              <template slot-scope="scope">

                <div>{{ scope.row.rate }}%</div>

              </template>
            </el-table-column>

            <el-table-column prop="equip.name" label="设备名称"></el-table-column>
            <el-table-column prop="equip.equip_no" label="设备终端号"></el-table-column>
            <el-table-column prop="equip.equip_imei" label="设备IMEI"></el-table-column>
<!-- 
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" @change="isDefaultChange(scope.row)"></el-switch>

              </template>
            </el-table-column> -->


            <el-table-column prop="create_time" label="关联时间" width="150"></el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
               
                <el-button  v-if="formInline.dtype" @click="canelBindClick(scope.row)" type="text" size="small">解绑设备</el-button>
                <el-button  @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <!-- <el-button @click="detailClick(scope.row)" type="text" size="small">收入明细</el-button> -->

              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" :dtype="formInline.dtype"  v-if="open_add" 
    :filiale_id_t="filiale_id_t" 
    :service_id_t="service_id_t"
    
    @close="closeAdd"></Add>
    <Edit :open_add="open_edit"  :dtype="formInline.dtype"
    :service_id_t="service_id_t"
    :equip_belong_id="equip_belong_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import EquipApi from '@/api/equip.js';
  import Add from './belong/add.vue';
  import Edit from './belong/edit.vue';
  import ServiceApi from '@/api/service.js';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          sales:"",
          status:-1,
          address:"",
          create_time:"",
          service:"",
          dtype:0,
          service_role_id:0
        },

        open_add:false,
        open_edit:false,
        equip_id:"",
        is_status:false,
 

        filiale_id_t:0,
        service_id_t:0,
        serviceRoleList:[]
      };
    },
    created() {
      this.is_status = false;
      this.formInline.service = this.$route.query.equip_no;
      this.formInline.dtype = this.$route.query.dtype;
      this.filiale_id_t = this.$route.query.equip_no;
      this.service_id_t = this.$route.query.equip_no;
      if(this.$route.query.equip_no){
        this.is_status = true;
      }
      /*获取列表*/
      this.getTableList();
      this.getServiceRole();
    },
    methods: {
  
      getServiceRole(){
      var self = this;
      ServiceApi.getServiceRole({
      
      }, true)
            .then(data => {
              self.serviceRoleList = data.data
    
      });
    },

      backClick(){
        this.$router.back(-1);
      },
      canelBindClick(item){//解绑设备
        var self = this;
        self.$confirm('是否解绑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        EquipApi.canelBindEquip({equip_belong_id:item.equip_belong_id}, true).then(data => {
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
      
      })


     

      },

 /* 设置默认 */
 isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let status = 1;
        if(row.status){
          status = 1;
        }else{
          status = 0;
        }
        self.loading = true;
        EquipApi.setBelongStatus({status:status,equip_belong_id:row.equip_belong_id}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_default = !row.is_default
      })
    },

      reast(){
        this.formInline = {
          search:"",
          sales:"",
          status:-1,
          address:"",
          service_role_id:0
        };
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        EquipApi.belong(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;

            for(var i=0;i<self.tableData.length;i++){
              self.tableData[i].status = self.tableData[i].status==1?true:false;
            }
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
        
      },
      detailClick(row){
        let self = this;
        self.$router.push({
          path: '/plus/equip/index',
          query: {
            type: "log",
            equip_no:row.equip.equip_no
          }
        });
      },
      /*编辑活动*/
      editClick(row) {
        this.equip_belong_id = row.equip_belong_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            EquipApi.del(
              {
                equip_id: row.equip_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/belong.vue